var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H6.5V5C6.5 6.38071 7.61929 7.5 9 7.5H15C16.3807 7.5 17.5 6.38071 17.5 5V4H18C19.1046 4 20 4.89543 20 6V12.1731H16.9143C16.7004 12.1731 16.4967 12.2644 16.3544 12.424L14.1714 14.8729L10.2741 10.5009C10.1318 10.3413 9.92814 10.25 9.71429 10.25C9.50043 10.25 9.29674 10.3413 9.15444 10.5009L5.94955 14.0962H4V6C4 4.89543 4.89543 4 6 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.5962V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V13.6731H17.2504L14.7313 16.4991C14.589 16.6587 14.3853 16.75 14.1714 16.75C13.9576 16.75 13.7539 16.6587 13.6116 16.4991L9.71429 12.1271L6.84556 15.3452C6.70326 15.5049 6.49957 15.5962 6.28571 15.5962H4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3V5C16 5.55228 15.5523 6 15 6H9C8.44772 6 8 5.55228 8 5V3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardAlt);
export default __webpack_public_path__ + "static/media/clipboard-alt.198e736aa3cb2ae5939743deeac58343.svg";
export { ForwardRef as ReactComponent };